// @flow
import translate from "./translate"
import type { Banner } from "./banner.types"

const maybeTranslate = (banner: Banner): string => {
  if (!banner) return banner

  const maybeTranslated = translate(banner.text, banner.values)
  const isTranslated = maybeTranslated !== banner.text.toLowerCase()
  return isTranslated ? maybeTranslated : banner.text
}

export default maybeTranslate
